// Medição desde o dia 1: Web Vitals, tempo até o primeiro indicador e latência por endpoint.
// Na v0 tudo vai para um buffer em memória (veja `window.__iuvoPerf` no console do navegador);
// a issue de telemetria troca o `flush` por POST /console/v1/telemetry.
export interface PerfSample {
  name: string;
  value: number;
  route?: string;
}

const buffer: PerfSample[] = [];
const MAX = 500;

function push(s: PerfSample) {
  buffer.push(s);
  if (buffer.length > MAX) buffer.splice(0, buffer.length - MAX);
  if (import.meta.env.DEV) console.debug(`[perf] ${s.name}${s.route ? ` ${s.route}` : ""}: ${Math.round(s.value)}`);
}

export function recordApiLatency(route: string, ms: number) {
  push({ name: "api", route, value: ms });
}

let firstKpi = false;
/** Chamado pela primeira tela que pinta um número de verdade. */
export function markFirstKpi() {
  if (firstKpi) return;
  firstKpi = true;
  push({ name: "time-to-first-kpi", value: performance.now() });
}

export async function startVitals() {
  const { onLCP, onINP, onCLS, onTTFB } = await import("web-vitals");
  const report = (m: { name: string; value: number }) => push({ name: m.name, value: m.value });
  onLCP(report);
  onINP(report);
  onCLS(report);
  onTTFB(report);
  (window as unknown as { __iuvoPerf: PerfSample[] }).__iuvoPerf = buffer;
}

export const perfSamples = () => [...buffer];
